import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-rendererCR',
    template: `
        <button title="Approve/Reject" mat-mini-fab color="accent" (click)="onClick($event)" [disabled]="params.data.disableApprove == true || params.data.statusId != 3 ? true : false">
        <mat-icon>check</mat-icon>
        </button>
        <button title="Edit" mat-mini-fab color="primary" (click)="onClick($event)" [disabled]="params.data.disableDelete == true || params.data.statusId != 3 ? true : false">
        <mat-icon>edit</mat-icon>
        </button>
        <button title="Delete" mat-mini-fab color="warn" (click)="onClick($event)" [disabled]="params.data.disableDelete == true || params.data.statusId != 3 ? true : false">
        <mat-icon>delete</mat-icon>
        </button>
        <button title="View/Download" mat-mini-fab color="accent" (click)="onClick($event)">
        <mat-icon>remove_red_eye</mat-icon>
        </button>
  `
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererCR implements ICellRendererAngularComp, OnDestroy {
    public params: any;
    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }
    agInit(params: any): void {
        this.params = params;
    }
    onClick($event: any): any {
        if (this.params.onClick instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            };
            this.params.onClick(params);
        }
    }
    ngOnDestroy(): any {
        // no need to remove the button click handler
        // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
    }
}
